export enum CommunicationsResponseOnVrcAudioUpdateError {
  unableToUpdateAudio = 'unableToUpdateAudio',
}
